window.ShippingCart = {

  DRAWERS: [
    '#xboost-upsell-slide-cart-root',
    '.xboost-cart-slide',
    '.xboost-slide-cart-width',
    '.xboost-slide-cart',
    '.cart-drawer',
    'cart-drawer',
    '.cart-notification',
    '.drawer'
  ],

  closeDrawer() {

  document
    .querySelector('.xb_slide_cart_close_button')
    ?.click();

  document.body.style.overflow = '';

  document.body.classList.remove(
    'overflow-hidden',
    'modal-open',
    'drawer-open',
    'cart-open'
  );

},

  async addTemporaryProduct(
    variantId
  ) {

    window.__shippingCalculator = true;

    await ShippingUtils.postJson(
      '/cart/add.js',
      {
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            _shipping_calculator: 'true'
          }
        }]
      }
    );

    setTimeout(() => {

      window.__shippingCalculator = false;

    }, 100);

  },

  async removeTemporaryProduct() {

    const cart =
      await ShippingUtils.getCart();

    const item =
      cart.items.find(
        item =>
          item.properties?._shipping_calculator
      );

    if (!item) return;

    await ShippingUtils.postJson(
      '/cart/change.js',
      {
        id: item.key,
        quantity: 0
      }
    );

    setTimeout(() => {
    }, 50);

  }

};

document.addEventListener(
  'cart:open',
  e => {

    if (
      !window.__shippingCalculator
    ) {
      return;
    }

    e.stopImmediatePropagation();

    requestAnimationFrame(() => {
      ShippingCart.closeDrawer();
    });

  },
  true
);